import { ENUM__ml_asset_family } from '@shared/dto/+model/sd/_enums/ENUM__ml_asset_family';
import { ENUM__ml_asset_type } from '@shared/dto/+model/sd/_enums/ENUM__ml_asset_type';
import { DTO__generation_tool } from '@shared/dto/generation/DTO__generation_tool';
import { FIELD__base } from '../../../_fields/_base/FIELD__base';
import { DTO_GRAPH__instance } from '../../../_graph/DTO_GRAPH__instance';
import { INVOCATION_GRID2D__view } from '../../../_invocations/grid2d/INVOCATION_GRID2D__view';
import { INVOCATION_IMAGE__viewport } from '../../../_invocations/image/INVOCATION_IMAGE__viewport';
import { INVOCATION_TOOL_VIEW__info } from '../../../_invocations/info/INVOCATION_TOOL_VIEW__info';
import { INVOCATION_SPANDREL__upscaler } from '../../../_invocations/spandrel/INVOCATION_SPANDREL__upscaler';
import { DECORATOR__generation_tool_ml_asset_requirement } from '../../_decorators/DECORATOR__generation_tool_ml_asset_requirement';
import { ENUM__graph_template_name } from '../../sd_1/ENUM__graph_template_name';

export class GENERATION_TOOL__image_edit__upscale {
  /*
   *
   */

  @DECORATOR__generation_tool_ml_asset_requirement(ENUM__ml_asset_family.VISION_SPANDREL__UPSCALER, ENUM__ml_asset_type.VISION)
  static create() {
    /*
     * ASSERTS
     */

    /*
     *
     */
    let out = new DTO__generation_tool();
    out.name = ENUM__graph_template_name.UPSCALE_IMAGE;

    /*
     * GRAPH
     */

    const graph = DTO_GRAPH__instance.CREATE_NEW();
    out.graph = graph;

    /*
     * GRID2D VIEW
     */
    const node__grid2d = INVOCATION_GRID2D__view.create_node_for(graph);

    /*
     *
     */
    const node__scale = INVOCATION_SPANDREL__upscaler.create_node_for(graph);
    graph.edge__try_add_for_fields(node__scale.image_out, node__grid2d.image);

    /*
     *
     */
    const node__viewport = INVOCATION_IMAGE__viewport.CREATE_VIEWPORT_FOR(graph, node__scale.image);

    /*
     * VIEW INFO
     */
    const node__info = INVOCATION_TOOL_VIEW__info.create_node_for(graph);

    /*
     * ML ASSETS
     */

    /*
     * VIEW
     */

    let fields__visible: FIELD__base[] = [node__viewport.image, node__scale.model, node__scale.tile_size];

    let field_column_id = node__scale.model.meta.field_id;

    out.view__add({ fields__visible, fields__stored: fields__visible, field_column_id });

    /*
     *
     */

    return out;
  }
}
